import $ from 'jquery';
import googleMaps from 'googlemaps';
/*
Uses google.maps.geocoder() to first return lat long based on text query
then uses lat long to return a zip code
// returns a promise obj
*/
function __getZipFromLatLong(lat, longitude) {
  return new Promise(function (resolve, reject) {
    return googleMaps()
      .then(function (google) {
        var point = new google.maps.LatLng(lat, longitude);
        new google.maps.Geocoder().geocode({
          latLng: point
        }, function (res, status) {
          var addressComponentsGrepResults = [];
          var zip;

          if (google.maps.GeocoderStatus.OK === status && typeof res[0] !== 'undefined') {
            // search address components for a postal code
            addressComponentsGrepResults = $.grep(res[0].address_components, function (element) {
              return (-1 < $.inArray('postal_code', element.types));
            });

            if (addressComponentsGrepResults.length) {
              zip = addressComponentsGrepResults[0].short_name;
            }

            if (zip) {
              if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip) == false) {
                reject('fail');
              } else {
                resolve(zip);
              }
            } else {
              reject('fail');
            }
          } else {
            reject('fail');
          }
        });
      })
      .catch(function (err) { console.warn('err in maps: ', err); });
  });
}

export default function (address) {
  var returnAddress = address;

  return new Promise(function (resolve, reject) {
    return googleMaps()
      .then(function (google) {
        if (address.indexOf(',') > -1) {
          var addressArr = address.split(',');
          var state = addressArr[1].trim().toLowerCase();
          if (state === 'pr') {
            returnAddress = addressArr[0] + ', Puerto Rico';
          } else if (state === 'vi') {
            returnAddress = addressArr[0] + ', Virgin Islands';
          }
        }

        new google.maps.Geocoder().geocode({
          address: returnAddress,
          componentRestrictions: {
            country: 'US'
          }
        }, function geoCodeSuccess(results, status) {
          var lat;
          var longitude;
          if (status === google.maps.GeocoderStatus.OK && typeof results[0] !== 'undefined') {
            lat = results[0].geometry.location.lat();
            longitude = results[0].geometry.location.lng();

            if (lat && longitude) {
              __getZipFromLatLong(lat, longitude)
                .then(function (res) { resolve(res); })
                .catch(function (res) { reject(res); });
            } else {
              reject('fail');
            }
          } else {
            reject('fail');
          }
        });
      })
      .catch(function (err) { console.warn('err in maps: ', err); });
  });
};
